import { createActionGroup, props } from '@ngrx/store';
import { BannerModel, BannerRequestModel } from '../../_models/banner.model';

export const BannersActions = createActionGroup({
  source: 'Banners',
  events: {
    'Load Banners': props<{ filters: any }>(),
    'Load Banners Success': props<{
      items: ReadonlyArray<BannerModel>;
      total: number;
      activeCount: number;
    }>(),
    'Load Banner': props<{ id: string }>(),
    'Load Banner Success': props<{ data: Readonly<BannerModel> }>(),
    'Add Banner': props<{ data: Readonly<BannerRequestModel> }>(),
    'Add Banner Success': props<{ data: Readonly<BannerModel> }>(),
    'Edit Banner': props<{ id: string; data: Readonly<BannerRequestModel> }>(),
    'Edit Banner Success': props<{ id: string; data: Readonly<BannerModel> }>(),
    'Toggle Banner': props<{ id: string; active: boolean }>(),
    'Toggle Banner Success': props<{ data: Readonly<BannerModel> }>(),
    'Remove Banner': props<{ id: string }>(),
    'Remove Banner Success': props<{ id: string }>(),
  },
});
